import React, { useState, useEffect } from 'react';
import CircularProgress from './CircularProgress';
import './GenerationCounter.scss';
import { axiosInstance } from '../../Services/axios';

const BUNDLE_SIZE = 10; // Each paid bundle contains 10 images

const GenerationCounter = ({ onLimitReached, usageInfo: externalUsageInfo }) => {
  const [usageInfo, setUsageInfo] = useState(externalUsageInfo || null);
  const [isLoading, setIsLoading] = useState(!externalUsageInfo);

  useEffect(() => {
    if (externalUsageInfo) {
      setUsageInfo(externalUsageInfo);
      setIsLoading(false);
    }
  }, [externalUsageInfo]);

  const fetchUsageInfo = async () => {
    try {
      const response = await axiosInstance.get('/brain-snap/stripe/usage-info');
      if (response.data.success) {
        setUsageInfo(response.data.data);
        if (!response.data.data.canGenerate && onLimitReached) {
          onLimitReached();
        }
      }
    } catch (error) {
      console.error('Error fetching usage info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!externalUsageInfo) {
      fetchUsageInfo();
    }
  }, []);

  if (isLoading || !usageInfo) {
    return null;
  }

  const { freeRemaining, paidRemaining, canGenerate } = usageInfo;

  // Determine which state to display
  // Priority: Paid tier > Free tier > Limited tier
  // If user has paid generations, show Pro tier even if free generations remain
  const displayPaid = paidRemaining > 0;
  const displayFree = !displayPaid && freeRemaining > 0;
  const displayLimited = !canGenerate && !displayPaid && !displayFree;

  let tier = 'default';
  let remaining = 0;
  let total = 0;

  if (displayPaid) {
    // Calculate total purchased based on remaining
    // Each bundle = 10 images, so if they have 9 remaining, they purchased 1 bundle (10 total)
    const totalPurchased = Math.ceil(paidRemaining / BUNDLE_SIZE) * BUNDLE_SIZE;
    tier = 'paid';
    remaining = paidRemaining;
    total = totalPurchased;
  } else if (displayFree) {
    tier = 'free';
    remaining = freeRemaining;
    total = 2; // Free tier max
  } else if (displayLimited) {
    tier = 'limited';
    remaining = 0;
    total = 0;
  }

  return (
    <div className="generation-counter">
      <CircularProgress remaining={remaining} total={total} tier={tier} />
    </div>
  );
};

export default GenerationCounter;
